import React from 'react';
import TeamsPanel from '../../shared/TeamsPanel';

export default function TeamSelectionActivity({ activity }) {
  return <div><h2>{activity.name}</h2><p>{activity.description || 'See the teams and their members. Event admins can create teams and assign members here.'}</p><TeamsPanel /></div>;
}
